import { advantages } from "@/mocks/homeData";

export default function AdvantagesSection() {
  const scrollToContact = () => {
    const el = document.querySelector("#contacto");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="ventajas" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-teal-600 text-sm font-semibold tracking-widest uppercase mb-3">
            Por Qué Elegirnos
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4">
            La diferencia
            <span className="text-teal-600"> Jek Cleaning</span>
          </h2>
          <p className="text-gray-500 text-lg max-w-2xl mx-auto">
            No somos solo un servicio de limpieza. Somos tu aliado de confianza para mantener tu espacio impecable.
          </p>
        </div>

        {/* Advantages Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {advantages.map((adv) => (
            <div
              key={adv.id}
              className="p-6 rounded-2xl border border-gray-100 hover:border-teal-100 hover:bg-teal-50/30 transition-all duration-200 group"
            >
              <div className={`w-12 h-12 flex items-center justify-center ${adv.bg} rounded-xl mb-4 group-hover:scale-110 transition-transform`}>
                <i className={`${adv.icon} ${adv.color} text-xl`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{adv.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{adv.description}</p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <p className="text-gray-600 text-lg mb-4">
            ¿Listo para experimentar la diferencia?
          </p>
          <button
            onClick={scrollToContact}
            className="bg-teal-500 hover:bg-teal-600 text-white font-bold px-10 py-4 rounded-full text-lg transition-colors cursor-pointer whitespace-nowrap inline-flex items-center gap-2"
          >
            <i className="ri-file-list-3-line"></i>
            Solicita tu Cotización Ahora
          </button>
        </div>
      </div>
    </section>
  );
}
